import { render, staticRenderFns } from "./multiple-choice.vue?vue&type=template&id=53a7cebe&scoped=true"
import script from "./multiple-choice.vue?vue&type=script&lang=js"
export * from "./multiple-choice.vue?vue&type=script&lang=js"
import style0 from "./multiple-choice.vue?vue&type=style&index=0&id=53a7cebe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a7cebe",
  null
  
)

export default component.exports